import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

const GeneralInfo = observer(class GeneralInfo extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const { RegisterStore } = this.props.store;

    if(this.name) {
      const data = {
        accountName: this.name.value
      }

      RegisterStore.updateProctor(data, this.props.nextStep);
    } else {
      this.props.nextStep();
    }
  }

  render() {
    const { translation } = this.props;
    const { SessionStore, SettingsStore } = this.props.store;
    const { userData } = SessionStore;
    const { userSettings } = SettingsStore;

    const noteText = translation.body.split('%contact support%')
    const contactLink = React.createElement(
      'a',
      {
        href: 'mailto:proctors@smarterproctoring.com?subject=Support%20Ticket'
      },
      translation.contact
    )

    if(!SessionStore.loading) {
      return(
        <form
          className="panel"
          onSubmit={(e) => this.props.checkValidity(e, this.handleSubmit)}
          noValidate
        >
          <div className="panel__header">
            <h3 className="panel__title">
              <legend>{translation.heading}</legend>
            </h3>
          </div>

          <fieldset className="panel__body">
            <p className="note note--prominent">
              {noteText[0]} {contactLink}{noteText[1]}
            </p>

            <ul className="fields">
              <li className="field--half">
                <label className="lbl-required" htmlFor="profile-fname">
                  {translation.name.first}
                </label>

                <span className="faux-input">{userData.firstName}</span>
              </li>
              <li className="field--half">
                <label className="lbl-required" htmlFor="profile-lname">
                  {translation.name.last}
                </label>

                <span className="faux-input">{userData.lastName}</span>
              </li>
              <li>
                <label className="lbl-required" htmlFor="profile-email">
                  {translation.email}
                </label>

                <span className="faux-input">{userData.email}</span>
              </li>

              {userSettings.type !== 'individual-proctor' &&
                <li>
                  <label className="lbl-required" htmlFor="profile-name">
                    {translation.name.account}
                  </label>

                  <input
                    type="text"
                    id="profile-name"
                    defaultValue={userSettings.accountName || ''}
                    ref={(input) => this.name = input}
                    required
                    aria-required="true"
                  />
                </li>
              }
            </ul>

            <div className="panel__actions actions">
              <button
                className="actions__btn actions__btn--primary"
                type="submit"
              >
                {translation.button}
              </button>
            </div>
          </fieldset>
        </form>
      )
    }

    return null;
  }
})

export default translate('GeneralInfo')(GeneralInfo);



// WEBPACK FOOTER //
// ./src/app/components/Checkup/GeneralInfo.js